













































import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { IGetCampaignItemsDto } from '@/bundles/Ad/dto';
import { useAdCampaignItem } from '@/bundles/Ad/composables/useAdCampaignItem';
import { useAdClient } from '@/bundles/Ad/composables/useAdClient';
import { Nullable } from '@/bundles/App/type';
import moment from 'moment';

import AdListTable from '@/bundles/Ad/components/AdListTable.vue';
import AppRangeDatePicker from '@/bundles/App/components/AppRangeDatePicker.vue';

export default defineComponent({
  name: 'AdListView',

  components: {
    AdListTable,
    AppRangeDatePicker,
  },

  setup() {
    const { tableOptions, pageOffset, optionsChangeEventHandler } = usePagination();
    const { adCampaignItems, listLoading, total, fetch, totals, downloadLoading, exportToExcel } = useAdCampaignItem();
    const { listLoading: adClientLoading, adClientItems, fetch: fetchClients } = useAdClient();
    const clientFilter = ref<Nullable<number>>(null);

    const todayDate = moment(Date.now()).format('YYYY-MM-DD');
    const sevenDaysDate = moment(Date.now()).add({ day: -7 }).format('YYYY-MM-DD');
    const dateRange = ref<string[]>([sevenDaysDate, todayDate]);

    onMounted(async function () {
      try {
        await fetchClients();
      } catch (error) {
        console.error(error.message);
      }
    });
    const queryParams = computed(() => {
      const params: IGetCampaignItemsDto = {
        skip: pageOffset.value,
        take: tableOptions.value.itemsPerPage,
      };
      if (tableOptions.value.sortBy?.length) {
        params.sort_by = tableOptions.value.sortBy[0];
      }

      if (tableOptions.value.sortDesc?.length) {
        params.sort_desc = tableOptions.value.sortDesc[0];
      }

      if (clientFilter.value) {
        params.client = clientFilter.value;
      }

      if (dateRange.value.length === 2) {
        params.date_range = dateRange.value
      }
      return params;
    });

    async function fetchWrapper() {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      try {
        await fetch(queryParams.value);
      } catch (error) {
        console.error(error.message);
      }
    }
    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });
    watch(() => clientFilter.value, () => fetchWrapper());
    watch(() => dateRange.value, (value: string[]) => {
      if (value.length === 0 || value.length === 2) {
        fetchWrapper();
      }
    }, { deep: true });

    function downloadWrapper() {
      exportToExcel(queryParams.value);
    }

    return {
      adCampaignItems,
      listLoading,
      total,
      totals,
      tableOptions,
      pageOffset,
      adClientLoading,
      adClientItems,
      clientFilter,
      dateRange,
      downloadLoading,
      downloadWrapper,
      optionsChangeEventHandler,
      fetchWrapper,
    };
  },
});
